import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IResource } from '../../../resources_interface';
import { ResourceInfo } from '../../../builders/resource_info_builder';

export class ResourceDetailContentController {
  private resource: IResource;
  private location: string;
  private resourceDetails: ResourceInfo[];
  private sortedResources: ResourceInfo[];

  constructor(
    private ResourceLinksEnum: any,
    private favoriteResourceCommand: ICommand,
    private unfavoriteResourceCommand: ICommand,
    private log: any
  ) {}

  $onInit() {
    this.refresh();
  }

  refresh() {
    if (!!this.resource) {
      this.location = this.ResourceLinksEnum.get('location').buildDisplay(this.resource.location);
      this.resourceDetails = _4.map(this.resource.resource_detail, (resourceDetail: ResourceInfo) => {
        return this.ResourceLinksEnum.get(resourceDetail.resource_display_type.key).buildDisplay(resourceDetail);
      });
      this.sortedResources = this.sortResources();
    }
  }

  sortResources(): ResourceInfo[] {
    const getTimeResources = _4.filter(
      this.resourceDetails,
      (rsrcDetail: any) => rsrcDetail.description.resource_display_type === this.ResourceLinksEnum.TIME
    );
    const getTimeArray = _4.map(getTimeResources, 'description.value');
    const getOtherResources = _4.filter(
      this.resourceDetails,
      (rsrcDetail: any) => rsrcDetail.description.resource_display_type !== this.ResourceLinksEnum.TIME
    );

    if (getTimeResources.length > 0) {
      const resource: ResourceInfo = _4.first(getTimeResources);
      (resource as any).timeArray = getTimeArray;
      getOtherResources.push(resource);
    }

    return _4.sortBy(getOtherResources, (resourceDtl: any) => {
      return resourceDtl.description.order;
    });
  }

  toggleFavorite(): void {
    this.resource.favorite_id
      ? this.unfavoriteResourceCommand(this.resource).catch(() =>
          this.log.user.error("Looks like I couldn't unfavorite that.")
        )
      : this.favoriteResourceCommand(this.resource).catch(() =>
          this.log.user.error("Looks like I couldn't favorite that.")
        );
  }

  isTimeInfo(resourceDetail: any): boolean {
    return resourceDetail.description.resource_display_type === this.ResourceLinksEnum.TIME;
  }
}

export class ResourceDetailContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-resources/src/components/places/resource_detail_content/resource_detail_content.html';
  public controller: any = ResourceDetailContentController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    resource: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/components/places/resource_detail_content/resource_detail_content.ts